import styled from "@emotion/styled";

interface ColorMatchContainerProps {
	columns: number;
}

export const ColorMatchContainer = styled.div<ColorMatchContainerProps>(({ columns, theme }) => ({
	display: "grid",
	gridTemplateColumns: `repeat(${columns}, 1fr)`,
	gap: 16,

	[theme.breakpoints.down("sm")]: {
		gridTemplateColumns: "1fr"
	}
}));
